import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="w-28 sm:w-40 shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title}配图`}
          title={`${item.title} - 杨幂动态`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 py-3 pr-3 md:py-4 md:pr-4 flex flex-col justify-center min-w-0">
        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
          <span className="px-2 py-0.5 rounded-md text-[11px] font-label bg-accent-100 text-accent-900">
            {item.category}
          </span>
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.date}</span>
        </div>
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2 hidden sm:block">{item.summary}</p>
      </div>
    </Link>
  );
}